<template>
  <div class="header-visual"
       :class="{ 'header-visual--image': image, 'header-visual--full': full }"
  >
    <div class="header-visual__background"/>
    <div v-if="image"
         class="header-visual__image"
         :style="{ 'background-image': `url(${image})` }"
    />
    <div v-if="image && overlay"
         class="header-visual__overlay"
    />
  </div>
</template>

<script>
export default {
  name: 'HeaderVisualMarketplace',
  props: {
    image: {
      type: String,
      default: undefined,
    },
    full: {
      type: Boolean,
      default: false,
    },
    overlay: {
      type: Boolean,
      default: true,
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/mixins/breakpoints-up.scss";

.header-visual {
  $self:       &;
  top:         0;
  right:       0;
  height:      auto;
  position:    relative;
  margin-left: -1.5rem;
  margin-right: -1.5rem;

  @include lg-up {
    height:      100%;
    width:       51%;
    z-index:     1;
    position:    absolute;
    left:        50%;
    margin-left: 0.75rem;
    margin-right: unset;
  }

  &__image,
  &__overlay {
    padding-top:       66%;
    width:             100%;

    mask-repeat:       no-repeat;
    mask-size:         114% auto;
    mask-position:     bottom center;
    mask-image:        url("/assets/img/shape-mob.svg");

    background-size:   cover;
    background-repeat: no-repeat;
    background-position: center center;

    @include lg-up {
      position: absolute;
      padding-top: auto;
      height:   100%;
    }
  }

  &__overlay {
    background: radial-gradient(
                        ellipse at top right,
                        rgba(255, 190, 98, 0.85),
                        rgba(255, 181, 73, 1)
                );

    #{ $self }__image {
      // makes the image slightly smaller than the orange overlay to avoid borders
      transform: scale(0.995, 0.995);
    }
  }

  &__background {
    position:    relative;
    padding-top: 70%;
    width:       100%;

    background:  rgb(225, 241, 255);
    background:  linear-gradient(
                         45deg,
                         rgba(225, 241, 255, 1) 0%,
                         rgba(237, 248, 255, 1) 100%
                 );

    mask-size:   114% auto;
    mask-position: bottom center;
    mask-repeat: no-repeat;
    mask-image:  url("/assets/img/shape-mob.svg");

    @include lg-up {
      padding-top: 98%;
      transform:   translateX(1%);
      mask-image:  url("/assets/img/header-full-overlay.svg");
      mask-position: bottom -10% right 0;
      mask-size:   100%;
      mask-repeat: no-repeat;
    }
  }

  &--image {
    #{ $self }__image,
    #{ $self }__overlay,
    #{ $self }__background {
      @include lg-up {
        padding-top: 95%;
        mask-image:  url("/assets/img/header-full-overlay.svg");
        mask-position: bottom -10% right 0;
        mask-size:   100%;
        mask-repeat: no-repeat;
      }
    }

    #{ self }__image {
      mask-position: bottom -10.5% right 0;
    }

    #{ $self }__overlay {
      position: absolute;
      top:      0;
      transform: scale(1.005); // anti-alisasing with image
    }

    #{ $self }__background {
      position: absolute;

      @include lg-up {
        padding-top: 98%;
        transform: translateX(1%);
      }
    }
  }

  &--full {
    top:   0;
    right: 0;
    height: auto;

    @include lg-up {
      width: 51%;
    }
  }
}
</style>
